import { useContext, useRef, useState } from 'react';
import debounce from 'lodash/debounce';

import type { GalleryDataProviderState } from 'Context/GalleryDataContext/GalleryDataContext';
import { GalleryDataContext } from 'Context/GalleryDataContext/GalleryDataContext';

import type { GalleryImageWithTitle } from './MainGallery/MainGallery';

export const useGalleryData = (): GalleryDataProviderState => {
	const data = useContext(GalleryDataContext);
	if (!data) {
		throw new Error('useVehiclePhotos must be used inside GalleryDataProvider');
	}
	return data;
};

export const useVehiclePhotosByKind = (kind: string[]): GalleryImageWithTitle[] => {
	const galleryData = useGalleryData();

	return galleryData.images.filter((image) => kind.includes(image.kind));
};

const IMAGES_UPDATE_DEBOUNCE = 300;

export const useDebounceFailedImages = () => {
	const failedImagesRef = useRef<Record<number, boolean>>({});
	const [failedImages, setFailedImages] = useState<Record<number, boolean>>({});

	const debouncedSetFailedImages = useRef(
		debounce(() => setFailedImages(() => ({ ...failedImagesRef.current })), IMAGES_UPDATE_DEBOUNCE),
	).current;

	const setFailedImage = (id: number) => {
		failedImagesRef.current[id] = true;
		debouncedSetFailedImages();
	};

	return { failedImages, setFailedImage };
};
